import { OVERSEA_COUNTRY, PROVINCE } from '@laigu/constants';
const contry = OVERSEA_COUNTRY;

const countryList = Object.keys(contry).map(val => {
  return {
    title: val,
    value: val,
    label: val,
    key: contry[val]
  };
});
// 原始的中国地区信息
const zone = PROVINCE;

// 方便反找省份
const cityList = [];

const provinceList = [];

//新接口去除特殊省份
const replaceLocation = data => {
  const reg = /省|市|自治区|特别行政区/g;
  data = data.replace(reg, '');
  const reg1 = /自治州|自治区|自治县/g;
  data = data.replace(reg1, '');
  const reg2 = /朝鲜族|地区|土家族|林区|苗族|黎族|藏族|羌族|依族|侗族|彝族|哈尼族|壮族|白族|景颇族|傈僳族|藏族|回族|蒙古族/g;
  data = data.replace(reg2, '');
  data = data === '中国' ? data : data + '%';
  return data;
};

// 去掉特殊省份
const getDataFromName = name => {
  return name
    .replace('特别行政区', '')
    .replace('新疆维吾尔自治区', '新疆省')
    .replace('内蒙古自治区', '内蒙古')
    .replace('西藏自治区', '西藏省')
    .replace('广西壮族自治区', '广西省')
    .replace('宁夏回族自治区', '宁夏省');
};
/** 去掉"省" "市" */
const getShortName = (name = '') => {
  const newName = getDataFromName(name);
  return newName.replace(/\u7701+$/, '').replace(/\u5e02+$/, '');
};

const provinceObj = {};

const cityObj = {};

const provinceTreeList = [
  {
    label: '国内',
    value: '中国',
    key: 'domestic',
    children: zone.map(item => {
      const { name, code, cities } = item;
      const proviceName = name;
      const obj = { label: name, value: name, code, key: code };
      provinceList.push({ ...obj });
      provinceObj[name] = code;
      if (cities && cities.length > 1) {
        obj.children = cities
          .filter(item => item.name !== '全部')
          .map(city => {
            const { name, code } = city;
            cityList.push({ city: name, province: proviceName });
            cityObj[name] = code;
            return { label: name, value: name, code, key: code };
          });
      }
      return obj;
    })
  }
].concat([{ label: '国外', value: 'overseas', key: 'overseas', children: countryList }]);

const flatProvince = [];

const flat = (data, pName) => {
  data.forEach(res => {
    const { label, value, key, code } = res;
    const obj = { label, value, key, code };
    if (pName) obj.parentName = pName;
    flatProvince.push(obj);
    if (res.children) flat(res.children, res.value);
  });
};
flat(provinceTreeList);
const useRegion = () => {
  return {
    contry,
    cityObj,
    flatProvince,
    provinceTreeList,
    provinceObj,
    provinceList,
    getShortName,
    replaceLocation,
    flat
  };
};

export default useRegion;
